import { InitOptions } from 'i18next';

import { i18nextFormatter } from './i18nextFormatter';

export const geti18NextConfig = (
  language: string,
  translation = {}
): InitOptions => ({
  lng: language,
  // the namespace separator is ':' by default, but this prevents using colons in non-translated text values.
  // we don't use namespaces, so let's set it to a more rare character.
  nsSeparator: '',
  returnNull: false,
  compatibilityJSON: 'v3',
  interpolation: {
    prefix: '__',
    suffix: '__',
    format: i18nextFormatter,
  },
  resources: {
    [language]: {
      translation,
    },
  },
  // if the key points to an object, let's return the key, instead of:
  // "key 'settings.account (en)' returned an object instead of string"
  returnedObjectHandler: (key: string) => key,
});
